/**
 * Created by Mark on 29/03/2017.
 */

import React from 'react';

export default class MedalGraphic extends React.Component {

    constructor(props) {
        super();
        this.props = props
    }

    getMedal(){
        if(this.props.medal)  return this.props.medal;
        if(!this.props.score) return 'no-score';

        if(this.props.score < 50) return 'blank';
        if(this.props.score < 70) return 'bronze';
        if(this.props.score < 90) return 'silver';

        return 'gold';
    }

    render() {
        return (<img src={"img/medals/"+(this.props.size || 25 )+"-"+(this.getMedal())+".png"}/>)
    }

}


// WEBPACK FOOTER //
// ./src/components/media/medal.image.js